import * as React from "react";
import "../scss/stationname.scss"
import iconTrain from "../img/Icon_Zug2.png"
import iconBus from "../img/Icon_Bus.jpg"
import { HelperFunctions } from "../util/HelperFunctions";

export interface StationNameProps {
    stationname: string,
    product?:number
}

export class StationNameComponents extends React.Component<StationNameProps, { stationname: string }> {
    constructor(props: StationNameProps) {
        super(props);
        this.state = {
            stationname: props.stationname,
        };
    }
    render() {
        let icon:any;
        var bitwiseOr = HelperFunctions.createBitwiseOrValue(this.props.product?.toString());
        if(bitwiseOr < 32)
            icon = iconTrain;
        else
            icon = iconBus;
        return (
            <div className="stationname-container">
                <div className="stationname-text">
                        <img src={icon} alt=""></img>
                        <span>{this.state.stationname}</span>
                </div>
            </div>
        );
    }
}

export default StationNameComponents;